import def from "csi/def";
import FieldConstructor, { Field } from "csi/def/Field";
import Relationship from "csi/def/Relationship";
import { View } from "csi/def/View";
import FormWidget from "csi/form/Widget";
import locale from "csi/locale";
import csi from "csi/main";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import Memory from "dojo/store/Memory";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

const FIELD_TARGET_PRODUCT_TYPE = "ProductType";

const MassAddFormulatedMaterialWizard = declare(FormWidget, {

	FIELD_MATERIAL_NAME: locale.type("FormulatedMaterial"),
	FIELD_TARGET_PRODUCT_TYPE: "ProductType",
	FIELD_RECIPE_TYPE: "RecipeDataSheetSubtype",
	FIELD_FORMULATED_MATERIAL_SUBTYPE: "FormulatedMaterialSubtype",
	FIELD_FORMULATED_MATERIAL: locale.type("FormulatedMaterial"),
	FIELD_TARGET_FOOD_TYPE: "FoodSubtype",
	FIELD_TARGET_FOOD: locale.type("Food"),
	SEARCH_FIELDS: "SearchFields",
	RECIPE_FIELD: "RecipeField",

	getFieldStore(field: Field, value: any) {
		// summary: drop-down options for Product Type
		const fieldName = field.getControlName();

		if (fieldName === this.FIELD_TARGET_PRODUCT_TYPE) {
			return new Memory({
				data: [
					{ id: this.FIELD_TARGET_FOOD, name: locale.type("Food") },
					{ id: this.FIELD_FORMULATED_MATERIAL, name: locale.type("FormulatedMaterial") },
				],
			});
		}
		return this.inherited(arguments);
	},

	_resolveView() {
		const foodType = lang.mixin(new Relationship(), {
			m_typeNode: "FoodSubtype",
			m_query: new Query()
			    .Attr("Active", xml.OP_EQUALS, true, "Child:Settings")
			    .Attr("TDSList", xml.OP_EQUALS, "FoodTypeDataSheet:RecipeDataSheet", "Child:Settings"),
		});

		const subtypeRelationship = lang.mixin(new Relationship(), {
			m_typeNode: "FormulatedMaterialSubtype",
			m_query: new Query()
			    .Attr("Active", xml.OP_EQUALS, true, "Child:Settings")
			    .Attr("TDSList", xml.OP_EQUALS, "FormulatedMaterialTypeDataSheet:RecipeDataSheet", "Child:Settings"),
		});

		const recipeTypeRelationship = lang.mixin(new Relationship(), {
			m_typeNode: "RecipeDataSheetSubtype",
			m_query: new Query()
			    .Attr("Active", xml.OP_EQUALS, true, "Child:Settings"),
		});

		this.insertField(lang.mixin(new FieldConstructor(), {
			m_label: "RecipeDataSheetSubtype",
			m_typeControl: def.FIELD_FILTERING_SELECT,
			m_relationship: recipeTypeRelationship,
		}), 0);

		this.insertField(lang.mixin(new FieldConstructor(), {
			m_label: this.FIELD_TARGET_FOOD_TYPE,
			m_typeControl: def.FIELD_FILTERING_SELECT,
			m_bRequired: true,
			m_relationship: foodType,
		}), 0);

		this.insertField(lang.mixin(new FieldConstructor(), {
			m_label: this.FIELD_FORMULATED_MATERIAL_SUBTYPE,
			m_typeControl: def.FIELD_FILTERING_SELECT,
			m_bRequired: true,
			m_relationship: subtypeRelationship,
		}), this.FIELD_TARGET_FOOD_TYPE);

		this.insertField(lang.mixin(new FieldConstructor(), {
			m_label: this.FIELD_TARGET_PRODUCT_TYPE,
			m_type: xml.ATTR_STRING,
			m_typeControl: def.FIELD_FILTERING_SELECT,
			m_bRequired: true,
			m_onChange: "onChangeProductType",
			idParameter: this.FIELD_TARGET_PRODUCT_TYPE,
		}), 0);

		this.insertField(lang.mixin(new FieldConstructor(), {
			m_label: this.FIELD_MATERIAL_NAME,
		}), this.FIELD_TARGET_PRODUCT_TYPE);

		// Insert header "Search Fields" before Formulated Material Name
		this.insertField(lang.mixin(new FieldConstructor(), {
			m_label: this.SEARCH_FIELDS,
			m_typeControl: def.FIELD_COMMENT,
		}), this.FIELD_MATERIAL_NAME);

		// Insert header "Recipe Fields" after last Search field name
		this.insertField(lang.mixin(new FieldConstructor(), {
			m_label: this.RECIPE_FIELD,
			m_typeControl: def.FIELD_COMMENT,
		}));

		this.insertField(lang.mixin(new FieldConstructor(), {
			m_label: "Amount",
			m_id: "QtyDefault",
			m_typeControl: def.FIELD_NUMBER,
		}));

		this.inherited(arguments);
	},

	onChangeProductType(formView: View, field: Field, value: any) {
		const productTypeField = this.defView.getFieldValue(FIELD_TARGET_PRODUCT_TYPE);
		const isFood = (productTypeField === this.FIELD_TARGET_FOOD);

		this.setFieldHidden(this.FIELD_TARGET_FOOD_TYPE, !isFood);
		this.setFieldHidden(this.FIELD_FORMULATED_MATERIAL_SUBTYPE, isFood);
		this.setFieldValue(isFood ? this.FIELD_FORMULATED_MATERIAL_SUBTYPE : this.FIELD_TARGET_FOOD_TYPE, csi.EMPTY_URL);
	},

	_buildFields(fields: Field[]) {
		this.inherited(arguments);

		const productTypeField = this.defView.getFieldValue(FIELD_TARGET_PRODUCT_TYPE);
		const isFood = (productTypeField === this.FIELD_TARGET_FOOD);

		this.setFieldHidden(this.FIELD_TARGET_FOOD_TYPE, !isFood);
		this.setFieldHidden(this.FIELD_FORMULATED_MATERIAL_SUBTYPE, isFood);
	},

});

export = MassAddFormulatedMaterialWizard;